<router-outlet *ngIf="appStateService.isReady; else loadingBlock"></router-outlet>
<ng-template #loadingBlock>
    <cas-loading></cas-loading>
</ng-template>

